const download = function (data, name) {
  let blob = new Blob([data])
  let link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
export { download }



// WEBPACK FOOTER //
// ./src/helpers/utils.js